import React, {useState} from 'react';
import './select-class.css';
import socketService from "../../services/socket";
import Modal from "../../components/modal/modal";
import classData from '../../datasets/class-detail.json';
import PersonDetail from "../../components/person-detail/person-detail"; // Import the JSON file

function SelectClass({roomSelected, detailClass, setDetailClass, setShowAvatar, stepPlayer, setStepPlayer}) {
    const [showModal, setShowModal] = useState(false);

    const showClass = (classSelected) => {
        const selectedClass = classData.classes.find(cls => cls.nome.toLowerCase() === classSelected.toLowerCase());
        if (selectedClass) {
            setDetailClass(selectedClass);
        }
        setShowModal(true);
    }

    return (
        <div>
            <Modal hidden={!showModal} setShowModal={setShowModal} textButton={'Escolher'} methodButton={() => {
                setStepPlayer('chosenCharacter')
                socketService.emit('chooseClass', {roomCode: roomSelected, playerClass: detailClass.nome});
                setShowModal(false);
                setShowAvatar(true);
            }}>
                {detailClass && <PersonDetail detailClass={detailClass}/>}
            </Modal>
            {stepPlayer === 'selectClass' ?
                (<div className={'body-class'}>
                    <h3>Clique abaixo em uma das classes</h3>
                    <div className="select-class">
                        <img src={'/img/min-class/anao.png'} onClick={() => showClass('Anão')}
                             className="class-category"/>
                        <img src={'/img/min-class/elfo.png'} onClick={() => showClass('Elfo')}
                             className="class-category"/>
                        <img src={'/img/min-class/humano.png'} onClick={() => showClass('Guerreiro')}
                             className="class-category"/>
                        <img src={'/img/min-class/mago.png'} onClick={() => showClass('Mago')}
                             className="class-category"/>
                        <img src={'/img/min-class/troll.png'} onClick={() => showClass('Troll')}
                             className="class-category"/>
                    </div>
                </div>) : (
                    <div className={'body-class'}>Aguarde seu oponente escolher a classe</div>
                )
            }
        </div>
    );
}

export default SelectClass;